import {Placement} from '@/common/interface/placementlist.data.model';
import {
    Component,
    ElementRef,
    HostListener,
    NgZone,
    OnInit,
    QueryList,
    Renderer2,
    ViewChildren
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {FarmService} from '@services/farm.service';
import {PlacementService} from '@services/placement.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-placement-list',
    templateUrl: './placement-list.component.html',
    styleUrl: './placement-list.component.scss'
})
export class PlacementListComponent implements OnInit {
    public placements: Placement[] = [];
    public flockNo: string = '';
    public displayDialog: boolean = false;
    public displayfeedingDialog: boolean = false;
    public displayWeeklyWeightDialog: boolean = false;
    public displayOdoWeightDialog: boolean = false;
    public displayVaccineDialog: boolean = false;
    public displayMedicationDialog: boolean = false;
    public displaydisinfectionDialog: boolean = false;
    public showDropdown: boolean = false;
    public activeRowIndex: number | null = null;
    public selectedPlanId: number | null = null;
    public selectedPlan: Placement | null = null;
    public diInfectionTypeId: number | null = null;
    private isDropdownClick: boolean = false;
    private dropdownElements: HTMLElement[] = [];
    public visibledrop: boolean = false;
    public loading = true;
    public totalRecords = 0;
    public userDetail: any;
    public filterForm: FormGroup;
    public displayDeleteDialog = false;
    public displayClosePlacementDialog = false;
    public itemToDelete: any;
    farmlist: any = [];
    farmhouselist: any = [];
    emptyMessage: string;
    @ViewChildren('dropdownMenu') dropdownMenus!: QueryList<ElementRef>;
    activeCycles: number = 0;
    totalChicks: number = 0;
    AvgMortality: number = 0;
    completedCycles: number = 0;

    constructor(
        private placementService: PlacementService,
        private elRef: ElementRef,
        private renderer: Renderer2,
        private ngZone: NgZone,
        private farmService: FarmService,
        private toastr: ToastrService,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.filterForm = this.fb.group({
            flockNo: [null],
            farmId: 0,
            farmHouseId: 0,
            expirationDate: [null]
        });
        const defaultFilterParams = {
            userId: this.userDetail.id,
            flockNo: '',
            placmentDate: null,
            farmId: 0,
            farmHouseId: 0,
            partitionId: 0
        };
        this.getPlacementList(defaultFilterParams);
        this.getFarmList(this.userDetail.id);

        //this.renderer.listen('document', 'click', (event: Event) => this.onDocumentClick(event));
    }

    // Computed flag: true when any modal/dialog is open
    get anyModalOpen(): boolean {
        return (
            this.displayDialog ||
            this.displayfeedingDialog ||
            this.displayWeeklyWeightDialog ||
            this.displayOdoWeightDialog ||
            this.displayVaccineDialog ||
            this.displayMedicationDialog ||
            this.displaydisinfectionDialog ||
            this.displayDeleteDialog ||
            this.displayClosePlacementDialog
        );
    }

    getFarmList(userId: number) {
        this.farmService.getFarmList(userId).subscribe((result) => {
            this.farmlist = result;
        });
    }
    onFarmChange(farmId: number): void {
        this.getFarmHouseList(farmId);
    }
    getPlacementList(filterParams: any) {
        this.loading = true;
        this.placementService
            .getPlacementList(filterParams)
            .subscribe((result) => {
                if (result.placements && result.placements.length > 0) {
                    this.placements = result.placements;

                    if (result.summary) {
                        this.activeCycles = result.summary?.activeCycles;
                        this.completedCycles = result.summary?.completedCycles;
                        this.totalChicks = result.summary?.totalBrids;
                        this.AvgMortality = result.summary?.avgMortality;
                    }

                    this.loading = false;
                } else {
                    this.placements = [];

                    this.activeCycles = 0;
                    this.completedCycles = 0;
                    this.totalChicks = 0;
                    this.AvgMortality = 0;

                    this.toastr.warning('No Records Found');
                    this.loading = false;
                }
            });
    }
    deletePlacement(item: any) {
        this.itemToDelete = item;
        this.displayDeleteDialog = true;
        // console.log(id);
    }
    deleteItem(id: number) {
        this.placementService.deletePlacement(id).subscribe((result) => {
            this.displayDeleteDialog = false;
            this.itemToDelete = null;
            this.toastr.success('Placement Deleted');

            const defaultFilterParams = {
                userId: this.userDetail.id,
                flockNo: '',
                placmentDate: null,
                farmId: 0,
                farmHouseId: 0,
                partitionId: 0
            };
            this.getPlacementList(defaultFilterParams);
        });
    }
    ClosePlacement(item: any) {
        this.itemToDelete = item;
        this.displayClosePlacementDialog = true;
        // console.log(id);
    }
    closecycleItem(id: number) {
        this.placementService.closePlacementById(id).subscribe((result) => {
            this.displayClosePlacementDialog = false;
            this.itemToDelete = null;
            this.toastr.success('Cycle Closed');

            const defaultFilterParams = {
                userId: this.userDetail.id,
                flockNo: '',
                placmentDate: null,
                farmId: 0,
                farmHouseId: 0,
                partitionId: 0
            };
            this.getPlacementList(defaultFilterParams);
        });
    }
    getFarmHouseList(farmId) {
        this.farmService.getFarmHouseList(farmId).subscribe((result) => {
            this.farmhouselist = result;
        });
    }
    clearFilter() {
        this.filterForm.reset();
        const defaultFilterParams = {
            userId: this.userDetail.id,
            flockNo: '',
            placmentDate: null,
            farmId: 0,
            farmHouseId: 0,
            partitionId: 0
        };
        this.getPlacementList(defaultFilterParams);
    }

    // Handler for custom inline search filter component
    onInlineFilter(values: any) {
        const filterParams = {
            userId: this.userDetail?.id,
            flockNo: values.flockNo || '',
            placmentDate: values.placmentDate || null,
            farmId: values.farmId ?? 0,
            farmHouseId: values.farmHouseId ?? 0,
            partitionId: values.partitionId ?? 0
        };
        this.getPlacementList(filterParams);
    }

    // Handler for custom inline filter clear action
    onClearFilter() {
        const defaultFilterParams = {
            userId: this.userDetail?.id,
            flockNo: '',
            placmentDate: null,
            farmId: 0,
            farmHouseId: 0,
            partitionId: 0
        };
        this.getPlacementList(defaultFilterParams);
    }
    openMortalityPopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openChicksFeedingPopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayfeedingDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openWeeklyWeightPopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayWeeklyWeightDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openOdoAverageWeightPopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayOdoWeightDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openVaccinePopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayVaccineDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openMedicationPopup(planId: number): void {
        this.selectedPlanId = planId;
        this.displayMedicationDialog = true;
        this.visibledrop = !this.visibledrop;
    }
    openDisInfectionPopup(planId: number, disinfectionId: number): void {
        console.log(disinfectionId);
        this.selectedPlanId = planId;
        this.diInfectionTypeId = disinfectionId;
        this.displaydisinfectionDialog = true;
        this.visibledrop = !this.visibledrop;
    }

    // Function to close the dialog
    closeDialog(): void {
        this.ngZone.runOutsideAngular(() => {
            this.displayDialog = false;
            this.displayfeedingDialog = false;
            this.displayWeeklyWeightDialog = false;
            this.displayOdoWeightDialog = false;
            this.displayVaccineDialog = false;
            this.displayMedicationDialog = false;
            this.displaydisinfectionDialog = false;
        });
    }

    toggleActiveSec(rowIndex: number, event: MouseEvent) {
        event.stopPropagation(); // Prevent the click event from bubbling up
        this.activeRowIndex =
            this.activeRowIndex === rowIndex ? null : rowIndex;
    }
    onCloseDisinfectionDialog() {
        this.displaydisinfectionDialog = false;
        this.displayMedicationDialog = false;
        this.displayVaccineDialog = false;
        this.displayfeedingDialog = false;
        this.displayWeeklyWeightDialog = false;
        this.displayOdoWeightDialog = false;
        this.displayDialog = false;
    }

    closeDropdownmain() {
        this.visibledrop = true;
    }

    openActionMenu(plan: Placement, event: MouseEvent) {
        event.stopPropagation();
        if (this.selectedPlan && this.selectedPlan.id !== plan.id) {
            this.selectedPlan = null;
        } else if (this.selectedPlan && this.selectedPlan.id === plan.id) {
            this.selectedPlan = null;
        } else {
            this.selectedPlan = plan;
        }
    }

    closeActionMenu() {
        this.selectedPlan = null;
    }

    // Function to reload placements after data is saved
    reloadPlacements(): void {
        //this.loadPlacements();
    }
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement | null;

        if (!target) {
            this.selectedPlan = null;
            this.activeRowIndex = null;
            return;
        }

        const isActionButton = target.closest('.btn-master-edit');
        const isDropdownMenu = target.closest('.fixed-dropdown-menu');

        if (!isActionButton && !isDropdownMenu) {
            this.selectedPlan = null;
            this.activeRowIndex = null;
        }
    }

    private isClickInsideDropdown(event: MouseEvent): boolean {
        return this.dropdownElements.some((dropdown) =>
            dropdown.contains(event.target as Node)
        );
    }
}
